import { Link } from "react-router-dom";
import { categories } from "@/mocks/varietyShows";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-5 cursor-pointer">
                <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                  <i className="ri-heart-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                  红桃影院
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                你的欢乐源泉，综艺精彩不停。
                <br />
                汇聚热门综艺、真人秀、脱口秀等多元内容，致力于打造一站式综艺娱乐平台。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-5">综艺分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-5">更多分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-5">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about#reputation"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    用户口碑
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about#contact"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    联系我们
                  </Link>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-6">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-background-300 hover:text-background-50 text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-background-300 hover:text-background-50 text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
                  rel="nofollow"
                >
                  <i className="ri-bilibili-line text-background-300 hover:text-background-50 text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 红桃影院 HongTao Movie. 本站内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                用户协议
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                版权声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}